export default __webpack_public_path__ + "static/media/Rune Stone of the Last Resort.6a297148.jpg";